import { CSSProperties } from "react";

type DividerGradientProps = {
  style?: CSSProperties;
};

const DividerGradient = (props: DividerGradientProps) => {

  return (
    <div
      style={{
        width: "100%",
        height: "0.5rem",
        borderRadius: "50px",
        background: "linear-gradient(90deg, #FDA0B8, #F9C26F)",
        ...(props.style)
      }}
    >
    </div>
  );
};

export default DividerGradient;